import { useState, useEffect } from 'react'
import { getPrayerRequests, createPrayerRequest, markPrayerAnswered, deletePrayerRequest } from '../supabase/api'

export function usePrayerRequests(pairId, userId) {
  const [prayers, setPrayers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!pairId) { setLoading(false); return }
    fetchPrayers()
  }, [pairId])

  const fetchPrayers = async () => {
    try {
      setLoading(true)
      const data = await getPrayerRequests(pairId)
      setPrayers(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const addPrayer = async (title, description) => {
    const data = await createPrayerRequest(pairId, userId, title, description)
    setPrayers(prev => [data, ...prev])
    return data
  }

  const toggleAnswered = async (prayerId, isAnswered) => {
    const data = await markPrayerAnswered(prayerId, isAnswered)
    setPrayers(prev => prev.map(p => p.id === prayerId ? data : p))
  }

  const removePrayer = async (prayerId) => {
    await deletePrayerRequest(prayerId)
    setPrayers(prev => prev.filter(p => p.id !== prayerId))
  }

  return { prayers, loading, error, addPrayer, toggleAnswered, removePrayer, refetch: fetchPrayers }
}